export var petriUrlMap = {
    new: {
        conductAllInScope: '/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/v1/laboratory/platform/conductExperiment',
    },
    old: {
        conductAllInScope: '/_api/wix-laboratory-server/laboratory/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/laboratory/conductExperiment',
    },
};
export var getAllInScopePath = function (scope, useNewApi) {
    if (scope === void 0) { scope = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? petriUrlMap.new.conductAllInScope + "?scope=" + encodeURIComponent(scope)
        : petriUrlMap.old.conductAllInScope + "?scope=" + encodeURIComponent(scope);
    return urlApi;
};
export function isValidScopeUrl(url, useNewApi) {
    return (url.indexOf(useNewApi
        ? petriUrlMap.new.conductAllInScope
        : petriUrlMap.old.conductAllInScope) !== -1);
}
export var getExperimentPath = function (key, fallback, useNewApi) {
    if (key === void 0) { key = ''; }
    if (fallback === void 0) { fallback = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? petriUrlMap.new.conductExperiment + "?key=" + encodeURIComponent(key) + "&fallbackValue=" + encodeURIComponent(fallback)
        : petriUrlMap.old.conductExperiment + "?key=" + encodeURIComponent(key) + "&fallback=" + encodeURIComponent(fallback);
    return urlApi;
};
export function isUrlOfExperiment(url, specName, useNewApi) {
    var pattern = "" + getExperimentPath(specName, '', useNewApi);
    return url.includes(pattern);
}
//# sourceMappingURL=urlMap.js.map